export const fieldsInfo: any = {
  // fields with full cell size
  fullSizeFields: [
    'filename',
    'uri',
    'description',
    'additional_info',
  ],
};
